<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Out of My Later Years</title>
<link href="default.css" rel="stylesheet" type="text/css"/>
<p class="ct"><a href="#/contents#tahir0001" id="tahir001">1</a></p>
<p class="ct1"><a href="#/contents#tahir0001">Publisher’s Preface</a></p>
<p class="tx1">THIS SECOND VOLUME of collected essays by Albert Einstein covers a period of about fifteen years—1934 to 1950; the first anthology, published under the title <i><i>The World As I See It,</i></i> comprising material from 1922 to 1934.</p>
<p class="tx">Albert Einstein does not belong to that group of scholars who live in the “ivory tower” of their research work, oblivious to the world around them. On the contrary, he has always been an astute and critical observer of the trends and needs of his time. Indeed, frequently did he intervene by written as well as spoken appeal, and always, we should like to emphasize, for a humanitarian cause.</p>
<p class="tx">In this sense <i>Out of My Later Years</i> mirrors the philosophical, as well as political and social attitudes of its author. The chapters themselves represent addresses, articles, letters, appeals and miscellaneous papers hitherto unpublished.</p>
<p class="tx">We feel privileged to offer them to the public with hardly any editorial change—a moving document of the workings of a conscientious, profound and deeply humane mind.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pub.vue?9e91f468